import { BaseApiService } from '../../../api/base';
import type {
  BrokerOfferApplicant,
  BrokerOfferDetails,
  BrokerOtpConfirmRequest,
  BrokerOtpConfirmResponse,
  BrokerOtpRequestResponse,
} from '../types/brokerOffer';

class BrokerOfferApiService extends BaseApiService {
  async getOffer(offerId: string): Promise<BrokerOfferDetails> {
    return this.get<BrokerOfferDetails>(`/broker/offers/${offerId}`);
  }

  async getApplicant(offerId: string): Promise<BrokerOfferApplicant> {
    return this.get<BrokerOfferApplicant>(`/broker/offers/${offerId}/applicant`);
  }

  async requestOtp(offerId: string): Promise<BrokerOtpRequestResponse> {
    return this.post<BrokerOtpRequestResponse>(
      `/broker/offers/${offerId}/request-otp`
    );
  }

  async confirmOtp(
    offerId: string,
    request: BrokerOtpConfirmRequest
  ): Promise<BrokerOtpConfirmResponse> {
    return this.post<BrokerOtpConfirmResponse>(
      `/broker/offers/${offerId}/confirm-otp`,
      request
    );
  }
}

export const brokerOfferApiService = new BrokerOfferApiService();
